import styled from 'styled-components';
import { Level, Box } from '@landr/maestro';

const ResponsiveWrapper = styled(Level)`
    width: 100%;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    ${({ theme }): string => theme.breakpoint('md')`
        max-width: 100vw;
    `}
`;

const ResponsiveBox = styled(Box)`
    width: 100%;
    flex: 0 1 50%;
    ${({ theme }): string => theme.breakpoint('md')`
        flex-basis: 100%;
    `}
`;

export const Styled = {
    ResponsiveWrapper,
    ResponsiveBox,
};
